/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterStone_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterStone_viewer";
};
export type SbSharedRefineMenuFilterStone_viewer$data = SbSharedRefineMenuFilterStone_viewer;
export type SbSharedRefineMenuFilterStone_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterStone_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterStone_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStone_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6baebc0795a4435bd2d9eea93a8897e0';
export default node;
